import React, { forwardRef } from "react";
import styles from "./styles/InputText.module.css";
import { capitalizeFirstLetter } from "../../../utils/utils";
/**
 * Inpur text component
 * ForwardRef is used to focus on the element when mounted since it is a component
 */
const InputText = forwardRef(
    (
        {
            label,
            inputId,
            inputValue,
            handleChangeFunction,
            handleKeyDownFunction,

            handleBlur,
            required,
            placeholder,
            standardPlaceholder,
            letterSpacing,
            textAlign,
            maxLength,
            type,
            data,
            disable,
            adaptFont,
            fullWidth,
            name,
        },
        ref
    ) => {
        return (
            <div
                className={`${styles.input_container} ${
                    fullWidth ? styles.full_width : ""
                } v-flex-container`}
            >
                <label className={`${styles.input_label}`} htmlFor={inputId}>
                    {label}
                    {label ? ":" : ""}
                </label>
                <input
                    ref={ref}
                    data-ex={data && data}
                    className={`${styles.input_element} ${
                        required && styles.alert
                    } ${disable ? styles.disabled : ""}  ${
                        adaptFont ? styles.adaptFont : ""
                    }`}
                    style={{
                        letterSpacing: letterSpacing,
                        textAlign: textAlign,
                    }}
                    type={type ? type : "text"}
                    name={name ? name : inputId}
                    id={inputId}
                    value={inputValue ?? ""}
                    placeholder={
                        required
                            ? capitalizeFirstLetter(placeholder)
                            : capitalizeFirstLetter(standardPlaceholder)
                    }
                    onChange={handleChangeFunction && handleChangeFunction}
                    onKeyDown={handleKeyDownFunction && handleKeyDownFunction}
                    maxLength={maxLength}
                    spellCheck={false}
                    autoComplete={"off"}
                    disabled={disable}
                    onBlur={handleBlur}
                />
            </div>
        );
    }
);

export default InputText;
